// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"374":"bd5cc18d8d80d8ef","432":"a995d8a1f77cd2b7"}[chunkId] + ".js";
};